import { Button, Form, Input, Modal } from "antd";
import React, { useState, useCallback, useEffect } from "react";
import AccountService from "../../../services/accounts.service";
import RemarkTags from "../../../components/remarkTags";
import { useTranslation } from "react-i18next";
import { allowOnlyAlphaNumericsShouldNotStartWithSpace } from "../../../services/common.service";

const remarksBill = require("../../../assests/icons/d_bill.png");
const remarksBusiness = require("../../../assests/icons/d_business.png");
const remarksEntertainment = require("../../../assests/icons/d_entertainment.png");
const remarksfood = require("../../../assests/icons/d_food.png");
const remarksHelth = require("../../../assests/icons/d_health.png");
const remarksOthers = require("../../../assests/icons/d_others.png");
const remarksShopping = require("../../../assests/icons/d_shopping.png");
const remarksTravel = require("../../../assests/icons/d_travel.png");
const remarksInvestment = require("../../../assests/icons/d_investment.png");
const remarksBillSelected = require("../../../assests/icons/g_bill.png");
const remarksBusinessSelected = require("../../../assests/icons/g_business.png");
const remarksEntertainmentSelected = require("../../../assests/icons/g_entertainment.png");
const remarksfoodSelected = require("../../../assests/icons/g_food.png");
const remarksHelthSelected = require("../../../assests/icons/g_health.png");
const remarksOthersSelected = require("../../../assests/icons/g_others.png");
const remarksShoppingSelected = require("../../../assests/icons/g_shopping.png");
const remarksTravelSelected = require("../../../assests/icons/g_travel.png");
const remarksInvestmentSelected = require("../../../assests/icons/g_investment.png");

export default function SetStatementRemarks({
  selectedDetails = {},
  accountDetails = {},
  setVisible,
  setRefresh,
}) {
  const [stage, setStage] = useState(1);
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [remarkTag, setRemarkTag] = useState({});
  const [message, setMessage] = useState("");
  const [visibleSuccess, setVisibleSuccess] = useState(false);
  const [remarksTagList, setRemarksTagList] = useState([
    {
      icon: remarksfood,
      iconSelected: remarksfoodSelected,
      label: t("pages.statement_remarks.food_and_drinks", {
        defaultValue: "Food and Drinks",
      }),
      iconStyle: { width: 25, height: 30 },
      value: "FOOD",
      active: false,
    },
    {
      icon: remarksEntertainment,
      iconSelected: remarksEntertainmentSelected,
      label: "Entertainment",
      iconStyle: { width: 30, height: 30 },
      value: t("pages.statement_remarks.entertainment", {
        defaultValue: "ENTERTAINMENT",
      }),
      active: false,
    },
    {
      icon: remarksBill,
      iconSelected: remarksBillSelected,
      label: t("pages.statement_remarks.utility_bills", {
        defaultValue: "Utility Bills",
      }),
      iconStyle: { width: 22, height: 30 },
      value: "BILLS",
      active: false,
    },
    {
      icon: remarksTravel,
      iconSelected: remarksTravelSelected,
      label: t("pages.statement_remarks.travel", {
        defaultValue: "Travel",
      }),
      iconStyle: { width: 30, height: 30 },
      value: "TRAVEL",
      active: false,
    },
    {
      icon: remarksHelth,
      iconSelected: remarksHelthSelected,
      label: t("pages.statement_remarks.health", {
        defaultValue: "Health",
      }),
      iconStyle: { width: 28, height: 26 },
      value: "HEALTH",
      active: false,
    },
    {
      icon: remarksInvestment,
      iconSelected: remarksInvestmentSelected,
      label: "Investment",
      iconStyle: { width: 28, height: 30 },
      value: t("pages.statement_remarks.investment", {
        defaultValue: "INVESTMENT",
      }),
      active: false,
    },
    {
      icon: remarksShopping,
      iconSelected: remarksShoppingSelected,
      label: t("pages.statement_remarks.shopping", {
        defaultValue: "Shopping",
      }),
      iconStyle: { width: 28, height: 30 },
      value: "SHOPPING",
      active: false,
    },
    {
      icon: remarksBusiness,
      iconSelected: remarksBusinessSelected,
      label: "Business",
      iconStyle: { width: 35, height: 30 },
      value: t("pages.statement_remarks.business", {
        defaultValue: "BUSINESS",
      }),
      active: false,
    },
    {
      icon: remarksOthers,
      iconSelected: remarksOthersSelected,
      label: "Others",
      iconStyle: { width: 30, height: 30 },
      value: t("pages.statement_remarks.others", {
        defaultValue: "OTHERS",
      }),
      active: false,
    },
  ]);

  useEffect(() => {
    if (Object.keys(selectedDetails).length > 0) {
      form.setFieldsValue({
        remarks: selectedDetails.remarks,
      });
      if (
        selectedDetails?.remarksTag !== null &&
        selectedDetails?.remarksTag?.length > 0
      ) {
        remarksTagList.forEach((ele) => {
          if (selectedDetails.remarksTag === ele.value) {
            ele.active = true;
          }
        });
        setRemarksTagList(remarksTagList);
      }
    }
  }, [selectedDetails, remarksTagList]);

  const onFinish = useCallback(
    async (values) => {
      try {
        setLoader(true);
        setVisible(false);
        const reqParams = {
          srcAccount: accountDetails?.accountNo,
          referenceNumber: selectedDetails?.refNo,
          remarks: values.remarks || null,
          remarksTag: remarkTag?.value || null,
        };
        const response = await AccountService.editMinistatement(reqParams);
        if (response.status === 200) {
          setLoader(false);
          setVisibleSuccess(true);
          setMessage(response.data["message"]);
          // setRefresh(reqParams);
          //   setStage(2);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [selectedDetails, remarkTag, accountDetails]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderSuccess();

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label={t("common.remarks", { defaultValue: "Reason" })}
            name="remarks"
            // rules={[{ required: true, message: "Reason is required" }]}
          >
            <Input
              size="large"
              maxLength={30}
              placeholder={t("common.remarks", { defaultValue: "Reason" })}
              onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
            />
          </Form.Item>

          {selectedDetails.debitOrCredit === "Debit" && (
            <>
              <p>
                {t("pages.statement_remarks.tag_expenditure", {
                  defaultValue: "Tag expenditure",
                })}
              </p>
              <RemarkTags
                setSelected={setRemarkTag}
                remarksTagList={remarksTagList}
              />
            </>
          )}

          <div align="right" className="mt-5">
            <Button
              type="default"
              size="large"
              className="secondary-btn mx-3"
              onClick={() => setVisible(false)}
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button type="primary" size="large" htmlType="submit">
              {t("buttons.save_btn", {
                defaultValue: "Save",
              })}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  function renderSuccess() {
    return (
      <>
        <p>
          {" "}
          {t("pages.my_accounts.common_my_accounts.acc_update_txt", {
            defaultValue: "Account name is updated successfully",
          })}
          .
        </p>
        <div align="right" className="mt-3">
          <Button type="link" onClick={() => setRefresh(false)}>
            {t("buttons.okay_btn", {
              defaultValue: "Okay",
            })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      <div>{renderSwitch()}</div>

      <Modal
        title={
          selectedDetails?.remarks !== null &&
          selectedDetails?.remarks?.length > 0
            ? t("pages.my_accounts.casa.edit_remarks", {
                defaultValue: "Edit Remarks",
              })
            : t("pages.my_accounts.casa.add_remarks", {
                defaultValue: "Add Remarks",
              })
        }
        closable={false}
        maskClosable={false}
        open={visibleSuccess}
        footer={null}
        width={360}
        mask={true}
      >
        <>
          <p>{message}</p>
          <div align="right" className="mt-3">
            <Button
              type="link"
              onClick={() => {
                setVisibleSuccess(false);
                setRefresh(true);
              }}
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </>
      </Modal>
    </>
  );
}
